import * as React from 'react';
import { Button } from '../../../Shared/components/button/button';

export interface IDuplicatePeriodModalProps {
	onCancel(): void;
	onShowRuns(): void;
}

export const DuplicatePeriodModal: React.StatelessComponent<IDuplicatePeriodModalProps> = (props: IDuplicatePeriodModalProps) => {
	const { onCancel, onShowRuns } = props;
	return (
		<div className="modal-content panel panel-plain">
			<Button className="close" aria-label="Close" onClick={onCancel}/>
			<div className="panel-heading"><h2>Duplicate time period</h2></div>
			<div className="panel-body">
						<p>A giving statements run already exists for this time period.</p>
						You should use this existing run to send statements for this period
			</div>
			<div className="panel-footer panel-footer-btn-group">
				<Button className="btn btn-cancel" aria-label="Close" onClick={onCancel}>Close</Button>
				<Button className="btn btn-primary" aria-label="Ok" onClick={onShowRuns}>Show previous runs</Button>
			</div>
		</div>
	);
};
